module.exports = __webpack_public_path__ + "static/media/podcast-background.746afa08.svg";